export default __webpack_public_path__ + "static/media/379329.9cf949ae.jpg";